import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { IExotelContextEngineResponse, IExotelContextEngineResponseData } from "@/api_framework/api_modals/Exotel";
import { EXOTEL_APIS } from "@/api_framework/api_config";

AxiosCurlirize(axios, () => {});
export const useExotelContextEngineAPI = () => {
  const [contextEngineData, setContextEngineData] = useState<IExotelContextEngineResponseData | null>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (customer_id: string, didNumber?: string | null) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const normalizeDid = (value: unknown) => {
          if (value === null || value === undefined) return null;
          return String(value).trim() || null;
        };
        // did_number sources: explicit param (call-details API) first, then
        // websocket payload persisted in sessionStorage.
        let did_number: string | null = normalizeDid(didNumber);
        if (!did_number) {
          try {
            const exotelInfoRaw = sessionStorage.getItem("exotel_information_current");
            did_number = exotelInfoRaw ? normalizeDid(JSON.parse(exotelInfoRaw)?.did_number) : null;
          } catch {
            did_number = null;
          }
        }
        const response = await axios
          .get<IExotelContextEngineResponse>(EXOTEL_APIS?.EXOTEL_CONTEXT_ENGINE?.baseURL ?? "", {
            params: { customer_id, ...(did_number ? { did_number } : {}) },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IExotelContextEngineResponse>) => {
            setContextEngineData(res.data.data ?? null);
            return res.data.data ?? null;
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            setContextEngineData(null);
            return null;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { contextEngineData, execute };
};
